import type { Repository } from "@octopusdeploy/octopus-server-client";
import { HostingEnvironment } from "@octopusdeploy/octopus-server-client";
export async function getLiveStatus(repository: Repository, projectId: string, kubernetesMonitorFeatureToggleEnabled: boolean) {
    const emptyLiveStatus = { ProjectLiveStatus: { Id: projectId, Environments: [] } };
    if (!kubernetesMonitorFeatureToggleEnabled) {
        return emptyLiveStatus;
    }
    const projectLiveStatusPromise = repository.KubernetesLiveStatus.getProjectDashboardLiveStatus(projectId);
    const licensePromise = repository.Licenses.getCurrentStatus();
    const serverNodesPromise = repository.OctopusServerNodes.all();
    const isSelfHosted = (await licensePromise).HostingEnvironment === HostingEnvironment.SelfHosted;
    const isRunningInHACluster = isSelfHosted && (await serverNodesPromise).length > 1;
    if (isRunningInHACluster) {
        return emptyLiveStatus;
    }
    return await projectLiveStatusPromise;
}
